import Navbar from "../components/sections/Navbar";
import Hero from "../components/sections/Hero";
import Marquee from "../components/sections/Marquee";
import Services from "../components/sections/Services";
import BeforeAfter from "../components/sections/BeforeAfter";
import Process from "../components/sections/Process";
import Reviews from "../components/sections/Reviews";
import FAQ from "../components/sections/FAQ";
import Contact from "../components/sections/Contact";
import Footer from "../components/sections/Footer";
import FloatingCTA from "../components/FloatingCTA";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-[#FAFAFA]">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <BeforeAfter />
        <Process />
        <Reviews />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <FloatingCTA />
    </div>
  );
}
